export default {
  id: "dayOfWeekPerformance",
  name: "",
  description: "",
  report: {
    name: "Day of Week Performance",
    template: "day-of-week",
    config: {
      dataType: "single",
      dataSet: "Sale",
      dimensions: ["Sale.sale_day_of_week"],
      measures: ["Sale.total_revenue", "Sale.total_gross_profit"],
      sort: {
        direction: "asc",
        by: "Sale.sale_day_of_week",
      },
      filters: [],
      compare: false,
      limit: "7",
      rowTotals: false,
      stacked: false,
      points: true,
      colorTheme: "default",
    },
  },
};
